import { useRef, useEffect, useCallback } from "react";

const useIsMounted = (): (() => boolean) => {
  const isMounted = useRef(true);
  useEffect(() => () => {
    isMounted.current = false;
  }, []);

  const isMountedCheck = useCallback((): boolean => isMounted.current, []);

  return isMountedCheck;
};

export { useIsMounted };
